import DallasStack from '@ui/Dallas/Stack/DallasStack';
import DallasText from '@ui/Dallas/Text/DallasText';
import { DallasFlexAlign } from '../../types/flex-align';
import { DallasSpacing } from '../../types/spacing';

export interface DallasOptionItem<T> {
  label: string;
  description?: string | React.ReactElement;
  value: T;
  disabled?: boolean;
  addOnStart?: React.ReactNode;
}

export interface DallasOptionItemProps<T> extends DallasOptionItem<T> {
  className?: string;
  addOnEnd?: React.ReactNode;
}

export interface DallasOptionItemContentProps<T>
  extends Pick<
    DallasOptionItemProps<T>,
    'className' | 'addOnStart' | 'addOnEnd' | 'label' | 'description'
  > {
  as?: 'div' | 'label';
  gap?: DallasSpacing;
  alignVertical?: DallasFlexAlign;
  paddingVertical?: DallasSpacing;
  paddingHorizontal?: DallasSpacing;
}

export function DallasOptionItemContent<T>({
  className,
  addOnStart,
  addOnEnd,
  label,
  description,
  as = 'div',
  gap = 'xs',
  alignVertical = 'center',
  paddingVertical = 'sm',
  paddingHorizontal = 'sm',
}: DallasOptionItemContentProps<T>) {
  return (
    <DallasStack
      className={className}
      direction="row"
      gap={gap}
      alignVertical={alignVertical}
      paddingVertical={paddingVertical}
      paddingHorizontal={paddingHorizontal}
      as={as}
    >
      {addOnStart}
      <DallasStack gap="none" flex>
        {label && <DallasText>{label}</DallasText>}
        {description ? (
          typeof description === 'string' ? (
            <DallasText variant="captionL" color="darkGray">
              {description}
            </DallasText>
          ) : (
            description
          )
        ) : null}
      </DallasStack>
      {addOnEnd}
    </DallasStack>
  );
}
